export default function (state = 0, action) {
   switch (action.type) {
      case "INCREMENT_ASYNC_ACTIONS_COUNT": {
         return state + 1;
      }
      case "DECREASE_ASYNC_ACTIONS_COUNT": {
         return state - 1;
      }

      default:
         return state;
   }
}



// WEBPACK FOOTER //
// ./src/reducers/asyncActionsCountReducer.js